import React from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { useSelector, useDispatch } from 'react-redux';
import Suppliers from '../../../../../../../../components/Suppliers';
import submitForm from './helpers/submitForm';

const MiseGdprForm = ({ id, s }) => {
  const dispatch = useDispatch();
  const selectedSuppliers = useSelector(
    state => state.Admin.data.suppliers.selectedSuppliers
  );

  const methods = useForm({
    defaultValues: {
      selectedSuppliers: selectedSuppliers,
    },
  });

  const onSubmit = (values) => {
    submitForm(values, dispatch, id);
  };

  return (
    <FormProvider {...methods}>
      <form className={s["mise-form-section"]} onSubmit={methods.handleSubmit(onSubmit)}>
        <h2>Adresskällor</h2>
        <Suppliers />
        <br />
        <button type="submit" className="btn btn--primary">Spara data</button>
      </form>
    </FormProvider>
  );
};

export default MiseGdprForm;